module.exports={
    shop: {
        store:'Store',
        stores:{
        	findPro:'Find stores',
        	allPro:'All stores',
            info:'Store information',
            uuid:'Number',
            address:'Address'
        },
        menus:[
            {
                name:'overview',
                key:'overview',
                text:'OVERVIEW'
            },{
                name:'products',
                key:'products',
                text:'PRODUCT'
            },{
                name:'label',
                key:'label',
                text:'ESL'
            },{
                name:'gateway',
                key:'gateway',
                text:'GATEWAY'
            },{
                name:'record',
                key:'record',
                text:'HISTORY'
            },{
                name:'shopsTemplates',
                key:'shopsTemplates',
                text:'TEMPLATE'
            },{
                name:'import',
                key:'import',
                text:'IMPORT'
            },{
                name:'settings',
                key:'settings',
                text:'SETTINGS'
            }
        ],
        overview:'OVERVIEW',
        products:'PRODUCT',
        label:'ESL',
        gateway:'GATEWAY',
        record:'HISTORY',
        authorization:'AUTHORIZATION',
        shopsTemplates:'TEMPLATE',
        import:'IMPORT',
        settings:'SETTINGS',
        submiting: 'Submitting...',
        storeMember:{
        	addMember:'Add store member',
        	members:'Store member'
        },
        warning:{
            title:'Alert message',
            selected:{
                brushFailed:'Brush failed',
                upgradeFailed:'Upgrade failed',
                bindFailed:'Bind failed'
            },
            bandTotal: 'Bind total：',
            bandFailed: 'Bind failed：',
            reUpdate:'ReUpdate',
            reUgrade:'Upgrade',
            failed:'Failed to query for warning information',
            noData:'No data',
            esl:'ESL ',
            rebrushSuccess:'The reflash command was sent successfully.',
            rebrushFailed:'The reflash command was sent failed.',
            reupgradeSuccess:'The upgrade command is sent successfully, and the ESL firmware is upgraded. Please keep the gateway online...',
            reupgradeFailed:'The upgrade command was sent failed.',

            batchRebrushFailed:'Batch reflash instruction failed to send',
            batchReupgradeFailed:'Batch upgrade command failed to send',

            noCheck:'Please tick the ESL you want to repaint',
            noBind:'The ESL does not have a binding gateway',
            updated:'This ESL has been updated',
            noUpgradePackage:'Upgrade package has been deleted or does not exist',
            versionError: 'Upgrade package version error',
            labelError: 'ESL exception',

            batchRebrushNoBind:'The re-brushing command failed to be sent, and the ESL does not have a binding gateway',
            batchRebrushUpdated:'Resend command failed to send, this ESL has been updated',

            batchReupgradeNoBind:'The upgrade command failed to be sent. The ESL is not bound to the gateway or the upgrade package does not exist.',
            batchReupgradeUpdated:'Upgrade command failed to send, no device exists'
        },
        progress:{
            brush:'Brush',
            upgrade:'Firmware upgrade',
            bind:'Bind',
            brushTotal:'Brush total：',
            brushSuccess:'Brush success：',
            upgradeTotal:'Firmware upgrade total：',
            upgradeSuccess:'Firmware upgrade success：',
            bingingTotal:'Bind total：',
            bingingSuccess:'Bind failed：',
            getProgressFailed:'Failed to get progress bar related data',
            resetProgressFailed:'Reset current store progress bar data failed'
        },
        addMemberTable:{
        	addMember:'Add member',
        	findMember:'Find members',
        	chooseMember:'Select member',
        	noData:'No data',
            add:'Add'
        },
        sure:'OK',
        member:'Store member',
        hintMsg:{
            queryStoreFail:'No inquiry to the store',
            queryAllStoreFail:'Querying all store information failed',
            queryUndistributedUser:'Did not query users who have not assigned a store',
            distributedMemberSuccess:'Assigning members to the store successfully',
            distributedMemberFail:'Assigning members to the store failed',
            // missPara:'缺少请求参数',
            chooseMember:'Please select a member',
            queryMemberFail:'Querying store member failed',
            queryStoreInfoFail:'Failed to get store information',
            alreadyDistributed:'The member has been assigned to the store'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/shop.js